<template>
  <div class="page-anniversary">
    <!-- 活动标题 -->
    <div v-wechat-title="'二周年，回到阿瑞斯小镇'"></div>
    <!-- 登录弹窗 -->
    <Login v-if="isShowLogin" v-on:channelCallback="selectCallback" :gameName="gameName" :noRoleName="true" game_id="41"
      :loginTypes="loginTypes" :downloadUrl="downloadUrl" channelTips="" noAuthLogin></Login>
    <Os v-if="isShowOs" v-on:selectCallback="selectCallback" v-on:logoutCallback="osCancell" :gameName="gameName"></Os>
    <!-- 头部 -->
    <div class="header">
      <div class="icon"></div>
      <div class="text top">阿瑞斯病毒2</div>
      <div class="text bottom">{{ userInfo.role_id ? maskedAccount : '二周年活动站'
      }}
      </div>
      <div class="btn download  monitor-btn" @click="downloadApps" data-snail-report-name="顶部下载游戏" data-event="download">
      </div>
      <div class="btn login" v-show="!userInfo.role_id" @click="changeLoginPopup(true)"></div>
      <div class="btn switch" v-show="userInfo.role_id && userInfo.os !== 'allChannel'" @click="changeOsPopup(true)">
      </div>
      <div class="btn logout" v-show="userInfo.role_id && userInfo.os == 'allChannel'" @click="logout()"></div>
    </div>

    <div class="active-page">
      <!-- <div class="main-container" id="main-container"> -->
      <div class="main-title"></div>
      <div class="banner-box"></div>
      <div class="banner-btn-box">
        <div class="btn lottery-btn" @click="scrollToDom('welfareBox')"></div>
        <div class="btn download-btn monitor-btn" @click="downloadApps" data-snail-report-name="首屏下载游戏"
          data-event="download"></div>
      </div>
      <div class="arrow-tips" @click="scrollToDom('welfareBox')"></div>

      <div class="content-01" ref="welfareBox">
        <div class="title"></div>
        <div class="welfare-box" :class="{ long: isWelfareLong }">
          <div class="rule-btn" @click="showPopup('ruleShow')" data-snail-report-name="活动说明"></div>
          <div class="participation-award-box" :class="participationAwardClass"></div>
          <div class="time-box" :class="{ ended: activityEnded }">
            <template v-if="activityEnded">
              <div class="activity-ended-line">活动已结束</div>
            </template>

            <template v-else>
              <div class="top-left-box top">距第{{ currentPeriodNoText || '--' }}期开奖</div>

              <div class="top-right-box top">
                第{{ currentPeriodNoText || '--' }}期开奖时间
              </div>

              <div class="left-box bottom">
                <span class="countdown-day-num">{{ countdown.days }}</span>
                <span class="countdown-day-unit">天</span>
                <span class="countdown-time">
                  {{ countdown.hours }}:{{ countdown.minutes }}:{{ countdown.seconds }}
                </span>
              </div>

              <div class="right-box bottom">
                <span class="draw-date-num">{{ currentEndDate.month }}</span>
                <span class="draw-date-unit">月</span>
                <span class="draw-date-num">{{ currentEndDate.day }}</span>
                <span class="draw-date-unit">日</span>
                <span class="draw-date-time">{{ currentEndDate.time }}</span>
              </div>
            </template>
          </div>
          <div class="lottery-box">
            <!-- 未登录 -->
            <div class="unLogin-box" v-if="!userInfo.role_id">
              <div class="login-btn" @click="changeLoginPopup(true);"></div>
            </div>

            <!-- 已登录 -->
            <template v-else>
              <div class="card-info-box">
                <div class="bind-account">{{ maskedRoleId || '--' }}</div>
                <div class="draw-code">{{ drawCode || '尚未绑定' }}</div>
                <div class="issue-number">第 {{ selectedPeriodNo || '--' }} 期</div>
              </div>

              <!-- 未绑定 -->
              <div class="unbound-box" v-if="!drawCode">
                <div class="tips"></div>
                <div class="download-btn monitor-btn" @click="downloadApps();" data-snail-report-name="活动页下载游戏"
                  data-event="download"></div>
              </div>

              <!-- 待开奖 -->
              <div class="unDrawn-box" v-else-if="selectedPeriodStatus !== 3">
                <div class="tips"></div>
              </div>

              <!-- 参与奖 -->
              <div class="unWin-box" :class="participationAwardClass" v-else-if="selectedReward === 0">
                <div class="cdk-box" id="cdk" :class="'cdk-'+ selectedPeriodNo" @click="handleCopy('#cdk', '复制成功')" :data-clipboard-text="cdk">
                  周年蛋糕*5、周年唱片*1：<span class="content">{{ cdk }}</span></div>
              </div>

              <!-- 1年月卡 -->
              <div class="lottery-month-card" v-else-if="selectedReward === 2"></div>

              <!-- 二周年礼盒 -->
              <div class="lottery-gift-box" v-else-if="selectedReward === 3">
                <div class="tips"></div>
                <!-- 购买后显示的：地址/收件信息 -->
                <a v-if="!address && !end_address" class="click-btn address-btn" data-snail-report-name="填写地址"
                  href="javascript:;" @click="openAddress"></a>
                <a v-if="address && !end_address" class="click-btn modify-btn" data-snail-report-name="修改地址"
                  href="javascript:;" @click="openAddress"></a>
                <a v-if="end_address" class="click-btn look-btn" data-snail-report-name="查看地址" href="javascript:;"
                  @click="openAddress"></a>
              </div>
            </template>

            <div class="nav-box">
              <div v-for="(item, index) in openRewardList" :key="item.id || index" class="nav-btn"
                :class="getPeriodNavClass(item, index)" @click="handlePeriodNavClick(item, index);">
                第{{ numberToChinese(index + 1) }}期
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="content-02">
        <div class="content-box"></div>
      </div>

      <div class="content-03">
        <div class="title"></div>
        <div class="game-feature-content">
          <div class="game-feature-swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="card in gameFeatureCards" :key="card.id">
                <img :src="card.image" alt="">
              </div>
            </div>
          </div>
          <div class="game-feature-swiper-button-next swiper-button-next"></div>
          <div class="game-feature-swiper-button-prev swiper-button-prev"></div>
          <div class="game-feature-swiper-pagination swiper-pagination"></div>
        </div>
      </div>

      <!-- 规则弹窗 -->
      <div class="rule-wrap popup_wrap" v-show="ruleShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="rule-box popup_wrap-box" v-show="ruleShow">
            <div class="content-box">
              <img src="../../../../assets/images/active/ares/secondAnniversary/rule_content.png" alt="">
            </div>
            <div class="confirm-btn" v-show="ruleShow" @click="closePopup('ruleShow')"></div>
            <div class="close-btn" v-show="ruleShow" @click="closePopup('ruleShow')"></div>
          </div>
        </transition>
      </div>

      <!-- 地址信息弹窗 -->
      <div class="address-wrap popup_wrap" v-show="addressShow">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"
          :duration="{ enter: 1000 }">
          <div class="address-box popup_wrap-box" v-show="addressShow">
            <!-- 姓名 / 手机号 / 省市区 -->
            <div class="detail-content-box">
              <div v-for="field in addressFields" :key="field.key" class="line-box" :class="field.class">
                <label>
                  <input :type="field.type" v-model.trim="$data[field.key]" :maxlength="field.maxlength"
                    :readonly="field.readonly" :disabled="end_address" :placeholder="field.placeholder"
                    @focus="handleAddressFocus(field);" />
                </label>
              </div>
            </div>

            <!-- 省市区点击热区，如果你有地区选择器就保留 -->
            <div class="city-box" @click="openAreaPicker();"></div>

            <!-- 详细地址 -->
            <div class="detail-address">
              <label>
                <textarea v-model.trim="address" :disabled="end_address" placeholder="请输入街道、门牌号等详细地址"></textarea>
              </label>
            </div>
            <div class="odd-number-box">
              <div class="odd-number">
                <label>
                  <input disabled type="text" :value="odd_number || no_add_number" />
                </label>
              </div>
              <div v-if="odd_number" id="odd_number" @click="handleCopy('#odd_number', '复制成功')"
                :data-clipboard-text="odd_number" class="copy-btn">复制
              </div>
            </div>
            <!-- 单号存在 或者禁止填写了 隐藏掉 -->
            <!-- 按钮区 -->
            <div class="address-btn-box">
              <div class="later-btn click-btn" @click="closePopup('addressShow')"></div>
              <div class="submit-address-btn click-btn" @click="submitInfo();"></div>
            </div>

            <!-- 已提交提示 -->
            <!-- <div class="address-submit-tips">地址已提交。</div> -->
            <div class="close-btn" @click="closePopup('addressShow')"></div>
          </div>
        </transition>
      </div>

      <!-- 省市区选择器 -->
      <van-popup v-model="showArea" position="bottom" round class="custom-popup">
        <van-area :area-list="areaList" @confirm="onConfirm" @cancel="showArea = false;" />
      </van-popup>

      <!-- 微信下载 -->
      <div class="wechat_download_wrap popup_wrap" v-show="wxLoadShow">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
          :duration="{ enter: 1000 }">
          <div class="wx_download_wrap_content" @click="wxLoadShow = false"></div>
        </transition>
        <div class="close-bg" v-if="wxLoadShow" @click="wxLoadShow = false"></div>
      </div>
    </div>
  </div>
</template>
<script>
// 按需引入 vant 组件
import { Popup, Area } from "vant";
import { areaList } from "@vant/area-data";
import Clipboard from "clipboard";
import { Indicator, Toast } from "mint-ui";

import Os from "../os";
import Login from "../login";
import { mapState, mapMutations, mapActions } from "vuex";
import { onGetInitDataAPI, onLogoutAPI, submitAddress, downloadApp } from "../api";
import { getTimeStamp, buriedLogger, wechatBrowser, analysisParams } from "@/utils/utils";
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

import "../../../../assets/js/howler";

export default {
  components: {
    Login,
    Os,
    [Popup.name]: Popup,
    [Area.name]: Area,
    swiper,
    swiperSlide,
  },
  data () {
    return {
      gameName: "ares",
      downloadUrl: 'https://ares2.qingcigame.com/',
      downloadUrls: {
        android_url: "https://ares2.qingcigame.com/adver/3/2.html",
        ios_url:
          "https://apps.apple.com/cn/app/%E9%98%BF%E7%91%9E%E6%96%AF%E7%97%85%E6%AF%922/id6503130455",
      },
      logger: null,
      // 其他数据
      loginTypes: ["sms", "password", "channel"],
      user_activity: {},
      user_userInfo: {},
      logoutShow: false,

      gameFeatureCards: [
        { id: 1, image: require('../../../../assets/images/active/ares/secondAnniversary/3/feature_01.png') },
        { id: 2, image: require('../../../../assets/images/active/ares/secondAnniversary/3/feature_02.png') },
        { id: 3, image: require('../../../../assets/images/active/ares/secondAnniversary/3/feature_03.png') },
        { id: 4, image: require('../../../../assets/images/active/ares/secondAnniversary/3/feature_04.png') },
        { id: 5, image: require('../../../../assets/images/active/ares/secondAnniversary/3/feature_05.png') },
        { id: 6, image: require('../../../../assets/images/active/ares/secondAnniversary/3/feature_06.png') },
      ],

      isDrawOpen: 1, // 是否开奖（1 未开奖 2 进行中 3 已开奖）
      drawNum: 1, // 期次
      drawCode: '', // 抽奖券编号
      openRewardList: [], // 抽奖不同期次的数据

      selectedPeriodIndex: -1,

      currentPeriod: null, // status = 2 所在的当前期次对象
      currentPeriodStatus: null,  // 当前期次状态
      currentPeriodNo: 0, // 当前期次 数字
      currentPeriodNoText: '',// 当前期次 中文大写
      currentPeriodStartAt: '', // 当前期次开始时间
      currentPeriodEndAt: '', // 当前期次结束时间
      currentReward: '', // 开奖结果

      cdk: '',

      activityEnded: false,

      selectedPeriod: null,
      selectedPeriodIndex: -1,
      selectedPeriodNo: 0,
      selectedPeriodNoText: '',
      selectedPeriodStatus: null,
      selectedReward: null,

      countdownTimer: null,
      targetDate: 0, // 倒计时目标时间戳，使用当前期次 endAt

      countdown: {
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00'
      },

      maskedAccount: '',
      maskedRoleId: '',

      remainingSeconds: 0,
      timer1: null,

      endAddress: false, // 是否还能填写地址
      end_time: '', // 地址填写时间倒计时
      addressDeadline: '',
      selectedPeriodEndAt: '',

      wxLoadShow: false, //微信下载弹窗
      ruleShow: false, // 规则弹窗
      addressShow: false, // 地址弹窗
      showArea: false, // 地区选择器
      end_address: false, // 是否禁止填写地址。* false：可以填写；* true：禁止填写。

      odd_number: '',
      no_add_number: '未发货',

      /**
       * 地址表单字段。
       */
      name: '',
      phone: '',
      selected: '',
      address: '', // 地址填写详细地址

      /**
       * 省市区拆分字段。
       */
      provincial: '',
      city: '',
      area: '',

      /**
       * Vant Area 数据。
       * 需要你项目中引入真实 areaList。
       */
      areaList,

      addressFields: [
        {
          key: 'name',
          class: 'name_class',
          type: 'text',
          maxlength: 20,
          readonly: false,
          placeholder: '请输入收件人姓名',
        },
        {
          key: 'phone',
          class: 'phone_class',
          type: 'tel',
          maxlength: 11,
          readonly: false,
          placeholder: '请输入收件手机号',
        },
        {
          key: 'selected',
          class: 'city_class',
          type: 'text',
          maxlength: 50,
          readonly: true,
          placeholder: '例如：广东省 广州市 天河区',
        },
      ],

    }
  },
  created () {
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();
    this.getLoginContainer();

    // 埋点
    const bl = buriedLogger("ares", "阿瑞斯2_二周年庆");
    this.logger = bl;
    const params = analysisParams(window.location.href);
    const { download_id, title } = params;
    downloadApp({ download_id, title }).then((res) => {
      if (res.code === 200) {
        this.downloadUrls = res.data
      }
    })
  },
  mounted () {
    this.initSwiperGameFeature();

    // 初始化
    this.$nextTick(() => {
      this.isSetShare();
      this.loadMonitorScript();
    });
    document.addEventListener('click', this.handleGlobalClick, true);
  },
  beforeDestroy () {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer)
      this.countdownTimer = null
    }
  },
  computed: {
    currentEndDate () {
      if (!this.currentPeriodEndAt) {
        return {
          month: '--',
          day: '--',
          time: '--:--'
        }
      }

      const date = this.parseDate(this.currentPeriodEndAt)

      return {
        month: String(date.getMonth() + 1),
        day: String(date.getDate()),
        time: `${this.pad(date.getHours())}:${this.pad(date.getMinutes())}`
      }
    },
    participationAwardClass () {
      return 'unWin-phase-' + this.selectedPeriodNo;
    },
    isWelfareLong () {
      if (!this.userInfo || !this.userInfo.role_id) {
        return false;
      }

      if (!this.drawCode) {
        return true;
      }
      // console.log("selectedReward", this.selectedReward);
      if (this.selectedReward === 3) {
        return true;
      }

      return false;
    },
    // 格式化为 47:59:59
    formattedTime () {
      const h = String(Math.floor(this.remainingSeconds / 3600)).padStart(
        2,
        "0"
      );
      const m = String(
        Math.floor((this.remainingSeconds % 3600) / 60)
      ).padStart(2, "0");
      const s = String(this.remainingSeconds % 60).padStart(2, "0");
      return `${h}:${m}:${s}`;
    },
    ...mapState(["userInfo", "activeInfo", "isShowLogin", "isShowOs"]),
  },
  watch: {
    userInfo: {
      handler (newValue, oldValue) {
        if (!newValue.role_id) {
          // TAG: 注销的时候
          this.shareImg = "";
        } else if (newValue.role_id !== oldValue.role_id) {
          // TAG: 初始登陆/切换角色的时候
        }
      },
    },
  },

  methods: {
    loadMonitorScript () {
      const scriptId = 'qc-monitor-transfer-script';

      if (document.getElementById(scriptId)) {
        return;
      }

      const script = document.createElement('script');

      script.id = scriptId;
      script.src = 'https://static2.qcplay.com/monitor/monitor-transfer.js';
      script.async = true;

      script.onload = () => {
        // console.log('monitor-transfer 加载成功。');
      };

      script.onerror = () => {
        console.warn('monitor-transfer 加载失败。');
      };

      document.body.appendChild(script);
    },
    // 事件委托
    handleGlobalClick (e) {
      let el = e.target;
      while (el && el !== document) {
        if (el.hasAttribute && el.hasAttribute('data-snail-report-name')) {
          const reportName = el.getAttribute('data-snail-report-name');
          this.logger.sum(`阿瑞斯2_二周年庆_${reportName}`);
          break;
        }
        el = el.parentNode;
      }
    },
    scrollToDom (refName) {
      this.logger.sum('阿瑞斯2_二周年庆_参与抽奖按钮');
      const target = this.$refs[refName];

      // console.log("target", target);

      if (!target) {
        return;
      }

      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    },
    initSwiperGameFeature () {
      this.gameFeatureSwiper = new Swiper('.game-feature-swiper-container', {
        slidesPerView: 1,
        loop: true,
        autoplay: 3000,
        pagination: '.game-feature-swiper-pagination',
        paginationClickable: true,
        nextButton: '.game-feature-swiper-button-next',
        prevButton: '.game-feature-swiper-button-prev',
      })
    },
    downloadApps () {
      const isWechat = wechatBrowser();
      if (isWechat) {
        this.wxLoadShow = true
      } else {
        const linkObj = this.downloadUrls;
        const isIOS = navigator.userAgent.match(/(iPhone|iPod|ios)/i);
        const targetLink = isIOS ? linkObj.ios_url : linkObj.android_url;

        if (targetLink) {
          setTimeout(() => {
            window.location.href = targetLink
          }, 200)
        }
      }
    },
    // 初始化
    async getLoginContainer () {
      onGetInitDataAPI().then(response => {
        this.onInitDataCallback({ ...response, needAccount: false });

        /**
         * 不管是否登录，只要有 open_reward，都要初始化期次、倒计时、导航栏。
         */
        if (response.data.open_reward) {
          this.handleOpenReward(response.data.open_reward);
        }

        if (response.code == 401) {
          this.changeLoginPopup(true);
          return;
        }

        // console.log("this.activeInfo:", this.activeInfo);
        this.handleOpenReward(this.activeInfo.open_reward || []);
        this.drawCode = this.activeInfo.draw_code;
        this.address = this.activeInfo.address;
        this.provincial = this.activeInfo.provincial;
        this.city = this.activeInfo.city;
        this.area = this.activeInfo.area;
        this.selected = this.provincial + " " + this.city + " " + this.area;
        this.name = this.activeInfo.name;
        this.phone = this.activeInfo.phone;
        this.address = this.activeInfo.address;
        this.end_address = this.activeInfo.end_address;
        this.odd_number = this.activeInfo.shipment_order;
        this.end_time = this.activeInfo.end_time;
        this.cdk = this.activeInfo.cdk;

        this.maskedAccount = this.maskAccount(this.userInfo.account);
        this.maskedRoleId = this.maskRoleId(this.userInfo.role_id);

      })
    },
    initCountdown () {
      if (!this.end_time) return;

      // 兼容 iOS：时间格式中 - 替换为 /
      const baseTime = new Date(this.end_time.replace(/-/g, "/"));
      const targetTime = new Date(baseTime.getTime() + 48 * 60 * 60 * 1000); // +48小时
      const now = new Date();
      const diff = Math.floor((targetTime - now) / 1000);
      this.remainingSeconds = diff > 0 ? diff : 0;

      // 启动倒计时
      this.timer1 = setInterval(() => {
        if (this.remainingSeconds > 0) {
          this.remainingSeconds--;
        } else {
          clearInterval(this.timer);
          this.timer1 = null;
        }
      }, 1000);
    },
    handleOpenReward (openReward) {
      if (!Array.isArray(openReward)) {
        openReward = [];
      }

      this.openRewardList = openReward;

      /**
      * 是否所有期次都已结束。
      */
      this.activityEnded = openReward.length > 0 && openReward.every(function (item) {
        return Number(item.status) === 3;
      });

      /**
      * time-box 用：只找 status = 2 的当前期次。
      */
      const currentIndex = openReward.findIndex(function (item) {
        return Number(item.status) === 2;
      });

      const lastEndedIndex = this.findLastEndedPeriodIndex(openReward);

      /**
      * time-box：
      * 1. 有进行中期次，展示进行中期次；
      * 2. 全部结束后，取最后一期数据用于左侧 00 倒计时和期次展示；
      */

      if (currentIndex !== -1) {
        this.setCurrentPeriod(openReward[currentIndex], currentIndex);
      } else if (lastEndedIndex !== -1) {
        this.setCurrentPeriod(openReward[lastEndedIndex], lastEndedIndex);
      } else {
        this.resetCurrentPeriod();
      }

      /**
       * lottery-box 优先保留用户当前选中的期次。
       * 例如用户切到第一期，接口刷新后仍然停留第一期。
       */
      if (
        this.selectedPeriodIndex !== -1 &&
        openReward[this.selectedPeriodIndex] &&
        this.isPeriodClickable(openReward[this.selectedPeriodIndex])
      ) {
        this.selectPeriod(this.selectedPeriodIndex);
        return;
      }

      /**
      * 首次进入页面时，默认选中当前期次。
      */
      if (currentIndex !== -1 && this.isPeriodClickable(openReward[currentIndex])) {
        this.selectPeriod(currentIndex);
        return;
      }

      if (lastEndedIndex !== -1) {
        this.selectPeriod(lastEndedIndex);
        return;
      }

      /**
       * 如果只有 status = 1 未开始，则不选中。
       */
      this.resetSelectedPeriod();
    },
    findLastEndedPeriodIndex (openReward) {
      let resultIndex = -1;

      openReward.forEach(function (item, index) {
        if (Number(item.status) === 3) {
          resultIndex = index;
        }
      });

      return resultIndex;
    },
    handlePeriodNavClick (item, index) {
      if (!this.isPeriodClickable(item)) {
        return;
      }

      this.selectPeriod(index);
      this.logger.sum(`阿瑞斯2_二周年庆_点击第${index + 1}期按钮`);
    },
    selectPeriod (index) {
      const period = this.openRewardList[index];

      if (!period) {
        this.resetSelectedPeriod();
        return;
      }

      this.selectedPeriod = period;
      this.selectedPeriodIndex = index;
      this.selectedPeriodNo = index + 1;
      this.selectedPeriodNoText = this.numberToChinese(this.selectedPeriodNo);
      this.selectedPeriodStatus = Number(period.status);
      this.selectedReward = Number(period.reward);
      this.selectedPeriodStartAt = period.startAt || '';
      this.selectedPeriodEndAt = period.endAt || '';
    },
    resetSelectedPeriod () {
      this.selectedPeriod = null;
      this.selectedPeriodIndex = -1;
      this.selectedPeriodNo = 0;
      this.selectedPeriodNoText = '';
      this.selectedPeriodStatus = null;
      this.selectedReward = null;
    },
    getPeriodNavClass (item, index) {
      const status = Number(item.status);
      const isSelected = this.selectedPeriodIndex === index;

      return {
        /**
         * 选中态：所有选中都用 li_01_bg。
         */
        'nav-now': isSelected,

        /**
         * 未开启：status = 1，置灰不可点。
         */
        'nav-lock': !isSelected && status === 1,

        /**
         * 当前期次未选中：status = 2，用 li_04_bg。
         */
        'nav-current': !isSelected && status === 2,

        /**
         * 往期未选中：status = 3，用 li_03_bg。
         */
        'nav-past': !isSelected && status === 3,
      };
    },

    isPeriodClickable (item) {
      const status = Number(item && item.status);

      return status === 2 || status === 3;
    },
    setCurrentPeriod (period, index) {
      this.currentPeriod = period;
      this.currentPeriodNo = index + 1;
      this.currentPeriodNoText = this.numberToChinese(this.currentPeriodNo);
      this.currentPeriodStatus = Number(period.status);
      this.currentReward = Number(period.reward);
      // console.log("this.currentReward", this.currentReward);
      this.currentPeriodStartAt = period.startAt || '';
      this.currentPeriodEndAt = period.endAt || '';

      this.targetDate = this.parseDate(period.endAt).getTime();

      this.updateCountdown();
      this.restartCountdownTimer();
    },
    resetCurrentPeriod () {
      this.currentPeriod = null;
      this.currentPeriodNo = 0;
      this.currentPeriodNoText = '';
      this.currentPeriodStatus = null;
      this.currentReward = null;
      this.currentPeriodStartAt = '';
      this.currentPeriodEndAt = '';
      this.targetDate = 0;

      this.countdown = {
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00',
      };

      this.clearCountdownTimer();
    },

    parseDate (dateStr) {
      if (!dateStr) {
        return new Date('');
      }

      return new Date(String(dateStr).replace(/-/g, '/'));
    },

    pad (value) {
      return String(value).padStart(2, '0');
    },

    updateCountdown () {
      if (!this.targetDate) {
        this.countdown = {
          days: '00',
          hours: '00',
          minutes: '00',
          seconds: '00',
        };
        return;
      }

      const now = Date.now();
      const diff = Math.max(0, this.targetDate - now);

      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);

      this.countdown = {
        days: this.pad(days),
        hours: this.pad(hours),
        minutes: this.pad(minutes),
        seconds: this.pad(seconds),
      };

      if (diff <= 0) {
        this.clearCountdownTimer();
      }
    },
    restartCountdownTimer () {
      this.clearCountdownTimer();

      this.countdownTimer = window.setInterval(() => {
        this.updateCountdown();
      }, 1000);
    },

    clearCountdownTimer () {
      if (this.countdownTimer) {
        window.clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    },
    maskAccount (account) {
      const str = String(account || '');

      if (!str) return '';

      // 标准手机号
      if (str.length === 11) {
        return str.slice(0, 3) + '****' + str.slice(7);
      }

      // 非 11 位账号，通用脱敏
      return this.maskMiddle(str, 3, 4);
    },
    maskMiddle (value, startLen = 3, endLen = 4) {
      const str = String(value || '');

      if (!str) return '';

      // 如果长度太短，就只保留首尾，中间一个 *
      if (str.length <= startLen + endLen) {
        if (str.length <= 2) return str;
        return str.slice(0, 1) + '*' + str.slice(-1);
      }

      const start = str.slice(0, startLen);
      const end = str.slice(-endLen);
      const starLength = str.length - startLen - endLen;
      const stars = '*'.repeat(starLength);

      return start + stars + end;
    },
    maskRoleId (roleId) {
      const str = String(roleId || '');

      if (!str) return '';

      return this.maskMiddle(str, 4, 4);
    },
    numberToChinese (num) {
      num = Number(num);

      const map = {
        1: '一',
        2: '二',
        3: '三',
        4: '四',
        5: '五',
        6: '六',
        7: '七',
        8: '八',
        9: '九',
        10: '十',
      };

      return map[num] || String(num);
    },
    openAddress () {
      // this.getLoginContainer();
      this.addressShow = true;
    },
    // 填写地址
    openAreaPicker () {
      if (this.end_address) {
        return;
      }

      this.showArea = true;
    },
    handleAddressFocus (field) {
      if (!field) {
        return;
      }

      if (field.key === 'selected' && !this.end_address) {
        this.showArea = true;
      }
    },
    onConfirm (e) {
      if (!e || !e.length) {
        this.showArea = false;
        return;
      }

      this.provincial = e[0] && e[0].name ? e[0].name : '';
      this.city = e[1] && e[1].name ? e[1].name : '';
      this.area = e[2] && e[2].name ? e[2].name : '';

      this.selected = this.provincial + ' ' + this.city + ' ' + this.area;
      this.showArea = false;
    },
    submitInfo () {
      // 如果已经发货的提示也不请求了
      if (this.odd_number !== 0 && this.odd_number !== "") {
        this.onToast("已成功发货，可复制单号查询物流！");
        return;
      }

      // 移除空白字符
      const filterSpaces = (str) => {
        return String(str || '').replace(/\s/g, '');
      };

      const params = {
        name: filterSpaces(this.name),
        phone: filterSpaces(this.phone),
        address: String(this.address || '').trim(),
        provincial: this.provincial,
        city: this.city,
        area: this.area,
      };

      if (!params.name) {
        this.onToast('收件人姓名不能为空');
        return;
      }

      // 手机号正则校验
      const phoneRegex = /^1[3-9]\d{9}$/;

      if (!phoneRegex.test(params.phone)) {
        this.onToast('请输入有效的手机号码');
        return;
      }

      if (!params.provincial || !params.city || !params.area) {
        this.onToast('省市区不能为空');
        return;
      }

      if (!this.validateAddress(params.address)) {
        return;
      }

      // console.log("params:", params);

      Indicator.open({
        text: '提交中...',
        spinnerType: 'fading-circle',
      });

      submitAddress(params).then((res) => {
        Indicator.close();

        if (res.code === 200) {
          this.addressShow = false;
          this.onToast(res.message || '地址提交成功');
          this.getLoginContainer();
        } else {
          if (res.message === '很抱歉,请求参数不正确') {
            this.onToast('尚未完成地址填写');
            return;
          }

          this.onToast(res.message || '地址提交失败，请稍后重试');
        }
        this.logger.sum('阿瑞斯2_二周年庆_提交地址按钮');
      }).catch((error) => {
        console.error(error);
        this.onToast('地址提交失败，请稍后重试');
      });
    },
    validateAddress (address) {
      const value = String(address || "").trim();

      if (!value) {
        this.onToast("详细收货地址不能为空");
        return false;
      }

      // 不能是纯数字
      if (/^\d+$/.test(value)) {
        this.onToast("详细地址不能为纯数字");
        return false;
      }

      if (value.length < 5) {
        this.onToast("详细地址不能少于5个字");
        return false;
      }

      if (value.length > 80) {
        this.onToast("详细地址不能超过80个字");
        return false;
      }

      // 不能全是符号
      if (!/[\u4e00-\u9fa5a-zA-Z0-9]/.test(value)) {
        this.onToast("详细地址格式不正确");
        return false;
      }

      /**
       * 重点：
       * 必须包含至少一个中文或英文字母。
       * 这样可以拦截：
       * 123-456
       * 1-2-301
       * #301
       * 88-2-101
       */
      if (!/[\u4e00-\u9fa5a-zA-Z]/.test(value)) {
        this.onToast("详细地址需包含街道、小区、楼栋或门牌等信息");
        return false;
      }

      // 禁止 emoji
      if (/[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(value)) {
        this.onToast("详细地址不能包含表情符号");
        return false;
      }

      // 禁止高风险特殊字符
      if (/[<>"'`\\&|]/.test(value)) {
        this.onToast("详细地址不能包含特殊字符");
        return false;
      }

      /**
       * 允许：
       * 中文、英文、数字、空格
       * 常见地址符号：- # _ / 、 ， , 。 . ： : ； ; （ ） ( )
       */
      const addressReg =
        /^[\u4e00-\u9fa5a-zA-Z0-9\s\-#_/、，,。.：:；;（）()]+$/;

      if (!addressReg.test(value)) {
        this.onToast("详细地址格式不正确，请勿输入特殊符号");
        return false;
      }

      return true;
    },
    saveAddressInfo () {
      const keepSelectedIndex = this.selectedPeriodIndex;

      const params = {
        role_id: this.userInfo && this.userInfo.role_id ? this.userInfo.role_id : '',
        account: this.userInfo && this.userInfo.account ? this.userInfo.account : '',
        draw_code: this.drawCode || '',
        period_no: this.selectedPeriodNo || '',
        receiver_name: this.name,
        receiver_phone: this.phone,
        receiver_region: this.selected,
        receiver_address: this.address,
      };

      // console.log('提交地址参数：', params);

      Indicator.open({
        text: '提交中...',
        spinnerType: 'fading-circle',
      });

      submitAddress(params).then((res) => {
        Indicator.close();

        if (res.code === 200) {
          this.addressShow = false;
          this.showToast(res.message || '地址提交成功。');

          /**
           * 保留当前点击的期次。
           */
          this.selectedPeriodIndex = keepSelectedIndex;

          if (this.getActivityInfo) {
            this.getActivityInfo();
          }

          return;
        }

        this.showToast(res.message || '地址提交失败，请稍后重试。');
      }).catch((error) => {
        Indicator.close();

        console.error(error);
        this.showToast('地址提交失败，请稍后重试。');
      });
    },
    showPopup (name) {
      this[name] = true;
    },
    closePopup (name) {
      this[name] = false;
    },
    selectCallback () {
      // this.loginMiddleShow = false
      this.getLoginContainer();
    },
    tipsMessage (message, times = 2000) {
      this.tipsShow = true;
      this.tips = message;
      setTimeout(() => {
        this.tipsShow2 = true;
      }, 100);
      setTimeout(() => {
        this.tipsShow2 = false;
      }, times - 200);
      setTimeout(() => {
        this.tipsShow = false;
        this.tips = "";
      }, times);
    },
    osCancell () {
      // 清空数据
      this.clearDate();
      this.getLoginContainer();
    },
    logout () {
      onLogoutAPI({ game_id: 41 }).then((res) => {
        if (res.code === 200) {
          this.osCancell();
          this.setInitUserInfo();
          this.setInitActiveInfo();
        } else {
          this.onToast(res.message, 2000);
        }
      });
    },
    clearDate () {
      this.drawCode = '';

      /**
       * 抽奖期次数据。
       */
      this.openRewardList = [];

      this.currentPeriod = null;
      this.currentPeriodNo = 0;
      this.currentPeriodNoText = '';
      this.currentPeriodStatus = null;
      this.currentReward = null;
      this.currentPeriodStartAt = '';
      this.currentPeriodEndAt = '';

      this.selectedPeriod = null;
      this.selectedPeriodIndex = -1;
      this.selectedPeriodNo = 0;
      this.selectedPeriodNoText = '';
      this.selectedPeriodStatus = null;
      this.selectedReward = null;
      this.selectedPeriodStartAt = '';
      this.selectedPeriodEndAt = '';

      /**
       * 倒计时。
       */
      this.targetDate = 0;

      this.countdown = {
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00',
      };

      this.clearCountdownTimer();

      /**
       * 地址信息。
       */
      this.addressShow = false;
      this.showArea = false;

      this.name = '';
      this.phone = '';
      this.receiverName = '';
      this.receiverPhone = '';

      this.provincial = '';
      this.city = '';
      this.area = '';
      this.selected = '';
      this.address = '';

      this.odd_number = '';
      this.no_add_number = '暂未发货';

      this.addressSubmitted = false;
      this.end_address = false;
      this.addressLoading = false;
      this.cdk = '';
    },
    // 打开登陆弹窗
    openLoginOS () {
      if (!this.userInfo.role_id) {
        this.changeLoginPopup(true);
      } else {
        this.logoutShow = true;
      }
    },
    // 统一复制逻辑
    handleCopy (my_id, successMsg) {
      const clipboard = new Clipboard(my_id);
      clipboard.on("success", (e) => {
        this.onToast(successMsg, 2000);
        e.clearSelection();
      });
      clipboard.on("error", (e) => {
        this.onToast("复制失败", 2000);
      });
    },
    onToast (config) {
      const curConfig = {
        duration: 2000,
        className: "toasts",
      };
      if (!config) {
        console.error("缺少config参数");
        return false;
      }
      if (typeof config === "string") {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    isSetShare () {
      this.setShare({
        link: `https://h5.qingcigame.com/ares/secondAnniversary/enter${getTimeStamp()}`,
        title: "二周年，回到阿瑞斯小镇",
        imgUrl:
          "https://download4.qcplay.com/qcgame-api/g7268NPCvE4QX7Inm40KDsJnhykbUpfFR0J1bdWx.png",
        desc: "找回属于你和阿瑞斯记忆，打卡小镇赢1年月卡、2周年周边、游园币。",
      });
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "confirmLogout",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup",
    ]),
    ...mapActions(["onInitDataCallback", "setShare"]),
  },
};
</script>

<style lang="less" scoped>
@import url("./index.less");

/deep/ .custom-popup {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  overflow: hidden;

  // shadows if needed
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
  // 强制白背景（避免被下面透出色）
  background: #fff;
}

/deep/ .van-area {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  overflow: hidden;
  background: #fff;
}

// 优化按钮字体
/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  font-size: 30px !important;
}

// 内容行高字体调大
/deep/ .van-picker-column__item {
  font-size: 30px !important;
}

/deep/ .van-picker {
  min-height: 300px !important;
}
</style>




// WEBPACK FOOTER //
// src/pages/ares/secondAnniversary/index/index.vue